import React, { SyntheticEvent } from 'react'
import styled from 'styled-components'
import { BORDER_RADIUS_SMALL } from '../../../constants'
import CreationToolSuperCutField from '../../../types/super-cut-field'
import { Title } from '../../typography'
import FieldTitle from './field-title'

const Container = styled.div`
    grid-column: span 2;
`

const Field = styled.div`
    align-items: center;
    background: #000;
    border-radius: ${BORDER_RADIUS_SMALL}px;
    box-sizing: border-box;
    color: #fff;
    display: flex;
    height: 70px;
    padding: 0 10px;
    width: 100%;
`

const TitleInput = styled(Title)`
    background: #000;
    color: #fff;
    margin: 0;
    width: 100%;
`

type Props = {
    field: CreationToolSuperCutField
    title?: string
    onChange: (title: string) => void
}

const CreationCaptureTitleField = ({ field, title, onChange }: Props) => {
    const description = CreationToolSuperCutField.description(field)
    const maxLength = CreationToolSuperCutField.maxCharacterCount(field)

    const onInput = (e: SyntheticEvent<HTMLInputElement, InputEvent>) => {
        onChange(e.currentTarget.value || '')
    }

    return (
        <Container>
            <FieldTitle field={field} />
            <Field>
                <TitleInput
                    {...{
                        as: 'input',
                        type: 'text',
                        defaultValue: title,
                        placeholder: description,
                        maxLength: maxLength || undefined,
                        onInput,
                    }}
                />
            </Field>
        </Container>
    )
}

export default CreationCaptureTitleField
